export const GET_PROJECT_INVESTED_ATTEMPT = 'GET_PROJECT_INVESTED_ATTEMPT';
export type GET_PROJECT_INVESTED_ATTEMPT = typeof GET_PROJECT_INVESTED_ATTEMPT;

export const GET_PROJECT_INVESTED_SUCCESS = 'GET_PROJECT_INVESTED_SUCCESS';
export type GET_PROJECT_INVESTED_SUCCESS = typeof GET_PROJECT_INVESTED_SUCCESS;

export const GET_PROJECT_INVESTED_FAILURE = 'GET_PROJECT_INVESTED_FAILURE';
export type GET_PROJECT_INVESTED_FAILURE = typeof GET_PROJECT_INVESTED_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/investment/get/Types.tsx